export default __webpack_public_path__ + "static/media/login-placeholder.34517887.png";